import { Calendar } from 'components/Calendar';
import React from 'react';

export const CalendarPage: React.FC = () => {
    return (
        <main id="calendar">
            <h2>Agenda</h2>
            <Calendar title="Calendrier" />
        </main>
    );
};
